import { render, staticRenderFns } from "./report-card.vue?vue&type=template&id=744d6260&scoped=true"
import script from "./report-card.vue?vue&type=script&lang=js"
export * from "./report-card.vue?vue&type=script&lang=js"
import style0 from "./report-card.vue?vue&type=style&index=0&id=744d6260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744d6260",
  null
  
)

export default component.exports